import { ParsedUrlQuery } from 'querystring';

/** Route / technical params that must not appear in public pagination links. */
export const PAGINATION_EXCLUDED_QUERY_KEYS = [
    'page',
    'isLoadMoreAvailable',
    'viewport',
    'brand',
    'category',
    'categories',
    'code',
] as const;

export const removePageQueryParam = (url: string): string => {
    const [pathname, search = ''] = url.split('?');
    const params = new URLSearchParams(search);

    params.delete('page');

    const queryString = params.toString();

    return queryString ? `${pathname}?${queryString}` : pathname;
};

/**
 * Builds query for pagination Links: keeps filters/sort/q, drops route + technical params.
 * Path already contains brand/category/code slug via getCorrectPathname(asPath).
 */
export const buildPaginationQuery = (
    query: ParsedUrlQuery,
    newPage: number,
    options: { isLoadMore?: boolean } = {}
): ParsedUrlQuery => {
    const excluded = new Set<string>(PAGINATION_EXCLUDED_QUERY_KEYS);
    const nextQuery: ParsedUrlQuery = {};

    Object.entries(query).forEach(([key, value]) => {
        if (excluded.has(key) || value === undefined) {
            return;
        }

        nextQuery[key] = value;
    });

    if (newPage > 1) {
        nextQuery.page = String(newPage);
    }

    if (options.isLoadMore && newPage > 1) {
        nextQuery.isLoadMoreAvailable = 'true';
    }

    return nextQuery;
};
